import { useEffect } from 'react'

const useDebounce = (value, callback, duration = 500, isArray = false) => {
    useEffect(
        () => {
            const timer = setTimeout(callback, duration)

            return () => {
                clearTimeout(timer)
            }
        },
        isArray ? value : [value],
    )
}

export default useDebounce
